import { render } from "./NFR.vue?vue&type=template&id=51fac876"
import script from "./NFR.vue?vue&type=script&lang=js"
export * from "./NFR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__